// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b2de13f1","57":"3774a306","124":"5f1043c5","353":"c599019c","449":"3ce57d68","453":"d5de1134","465":"a1a788af","660":"09f4afd0","697":"f332678a","712":"b62c38df"}[chunkId] + ".chunk.js";
};